export default __webpack_public_path__ + "static/media/720.c25406c6.gif";